import backgrounds from "../imgs/bottles/backgrounds/index";
import data from "../data";

let backgroundTemplates = [];

const foldersToImport = [
    {
        images: backgrounds.ChineseNewYear,
        keyPrefix: 'chinese_new_year__'
    },
    {
        images: backgrounds.Christmas,
        keyPrefix: 'christmas__'
    },
    {
        images: backgrounds.FathersDay,
        keyPrefix: 'fathers_day__'
    },
    {
        images: backgrounds.General,
        keyPrefix: 'general__'
    },
    {
        images: backgrounds.Love,
        keyPrefix: 'love__'
    }
];

const topText = {
    value: "",
    placeholder: data.copy("enterYourMessageHere"),
    fontSize: 23,
    maxLength: 26,
    fontFamily: "JWCaps",
    x: 0,
    y: -51,
};

const headingText = {
    value: "",
    placeholder: data.copy("egMissYou"),
    fontSize: 34,
    maxLength: 11,
    fontFamily: "JWSansBold",
    x: 0,
    y: -9,
};

const signatureText = {
    value: "",
    placeholder: data.copy("enterYourMessageHere"),
    fontSize: 10,
    maxLength: 30,
    fontFamily: "JWScriptRegular",
    x: 0,
    y: 22,
};

const darkThemeText = [
    {
        ...topText,
        colour: "#EFEFDF"
    },
    {
        ...headingText,
        colour: "#CBA86A",
    },
    {
        ...signatureText,
        colour: "#CBA86A"
    }
];

const doubleBlackTheme = [
    {
        ...topText,
        colour: "#EFEFDF"
    },
    {
        ...headingText,
        placeholder: data.copy("egThankYou"),
        colour: "#CBA86A",
    },
    {
        ...signatureText,
        colour: "#CBA86A"
    }
];

const redThemeText = [
    {
        ...topText,
        colour: "#EFEFDF"
    },
    {
        ...headingText,
        placeholder: data.copy("egLoveYou"),
        colour: "#E59F00",
    },
    {
        ...signatureText,
        colour: "#CBA86A"
    }
];

const greenTheme = [
    {
        ...topText,
        colour: "#E9C254",
        y: -43,
    },
    {
        ...headingText,
        placeholder: data.copy("egThankYou"),
        colour: "#FFFFFF",
        y: 2
    },
    {
        ...signatureText,
        colour: "#E9C254",
        y: 31
    }
];

const goldTheme = [
    {
        ...topText,
        colour: "#1D1D1B",
        y: -43
    },
    {
        ...headingText,
        placeholder: data.copy("egHeresToYou"),
        colour: "#1D1D1B",
        y: -2,
    },
    {
        ...signatureText,
        colour: "#1D1D1B",
        y: 31
    }
];

const platinumTheme = [
    {
        ...topText,
        colour: "#372E2D",
        y: -43
    },
    {
        ...headingText,
        placeholder: data.copy("egCongrats"),
        colour: "#BB965B",
        y: 2
    },
    {
        ...signatureText,
        colour: "#372E2D",
        y: 31
    }
];

backgroundTemplates.push(
    {
        id: "jw_black_template",
        isFixed: true,
        background: backgrounds.Templates.Backgrounds.jw_black,
        preview: backgrounds.Templates.Previews.jw_black,
        productIds: ['jw_black'],
        text: darkThemeText
    },
    {
        id: "jw_double_black_template",
        isFixed: true,
        background: backgrounds.Templates.Backgrounds.jw_double_black,
        preview: backgrounds.Templates.Previews.jw_double_black,
        productIds: ['jw_double_black'],
        text: doubleBlackTheme
    },
    {
        id: "jw_red_template",
        isFixed: true,
        background: backgrounds.Templates.Backgrounds.jw_red,
        preview: backgrounds.Templates.Previews.jw_red,
        productIds: ['jw_red'],
        text: redThemeText
    },
    {
        id: "jw_green_template",
        isFixed: true,
        background: backgrounds.Templates.Backgrounds.jw_green,
        preview: backgrounds.Templates.Previews.jw_green,
        productIds: ['jw_green'],
        text: greenTheme
    },
    {
        id: "jw_gold_template",
        isFixed: true,
        background: backgrounds.Templates.Backgrounds.jw_gold,
        preview: backgrounds.Templates.Previews.jw_gold,
        productIds: ['jw_gold'],
        text: goldTheme
    },
    {
        id: "jw_platinum_template",
        isFixed: true,
        background: backgrounds.Templates.Backgrounds.jw_platinum,
        preview: backgrounds.Templates.Previews.jw_platinum,
        productIds: ['jw_platinum'],
        text: platinumTheme
    }
);


foldersToImport.forEach(folderData => {
    const images = folderData.images;

    Object.keys(images).forEach(fileName =>
        backgroundTemplates.push({
            id: folderData.keyPrefix + fileName,
            isFixed: false,
            background: images[fileName],
            preview: images[fileName],
            productIds: [fileName],
            text: []
        })
    );
});

backgroundTemplates.push(
    {
        id: "jw_black",
        background: backgrounds.jw_black,
        preview: backgrounds.jw_black,
        productIds: ['jw_black'],
        isFixed: false,
        text: []
    },
    {
        id: "jw_double_black",
        background: backgrounds.jw_double_black,
        preview: backgrounds.jw_double_black,
        productIds: ['jw_double_black'],
        isFixed: false,
        text: []
    },
    {
        id: "jw_gold",
        background: backgrounds.jw_gold,
        preview: backgrounds.jw_gold,
        productIds: ['jw_gold'],
        isFixed: false,
        text: []
    },
    {
        id: "jw_green",
        background: backgrounds.jw_green,
        preview: backgrounds.jw_green,
        productIds: ['jw_green'],
        isFixed: false,
        text: []
    }
);


export default backgroundTemplates;



// WEBPACK FOOTER //
// ./src/data/background-templates.js